import {Columns} from '@shared/interfaces/table/column-config';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const readingcharacteristicsPartial: Columns<any> = {
  title: 'meteringPoint.readingCharacteristics.title',
  key: 'readingCharacteristics',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'meteringPoint.readingCharacteristics.notSpecified',
    none: 'meteringPoint.readingCharacteristics.none',
    automaticmeterreading: 'meteringPoint.readingCharacteristics.automaticMeterReading',
    manualmeterteading: 'meteringPoint.readingCharacteristics.manualMeterReading'
  }
}
